/**
 * Analytics AI agent — grounded insights + Q&A over the business analytics dashboard.
 */

/** Icon/tone vocabulary the frontend knows how to render */
export enum AnalyticsAiInsightIconEnum {
  Star = 'star',
  Cancel = 'cancel',
  Clock = 'clock',
  Money = 'money',
  Users = 'users',
  Chart = 'chart',
}

/** Deep-link targets an insight CTA can point to */
export enum AnalyticsAiCtaActionEnum {
  Automations = 'automations',
  LoyaltyProgram = 'loyalty-program',
  Services = 'services',
  Payments = 'payments',
}

export interface IAnalyticsAiInsight {
  icon: AnalyticsAiInsightIconEnum;
  /** Short finding in Hebrew, 1-2 sentences with concrete numbers */
  text: string;
  cta?: {
    label: string;
    action: AnalyticsAiCtaActionEnum;
  };
}

/**
 * Insights are always computed over the last 30 days and cached server-side
 * per business per calendar day — the request carries no range.
 */
export type IAnalyticsAiInsightsRequest = Record<string, never>;

export interface IAnalyticsAiInsightsResponse {
  /** false when admin AI is disabled for the business */
  enabled: boolean;
  insights: IAnalyticsAiInsight[];
  /** Period-aware suggested questions (Hebrew) */
  suggestedQuestions: string[];
}

export interface IAnalyticsAiChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface IAnalyticsAiChatRequest {
  message: string;
  conversationHistory: IAnalyticsAiChatMessage[];
  /** Optional grounding period — omitted (e.g. chat drawer) = last 30 days */
  startDate?: string;
  endDate?: string;
}

export interface IAnalyticsAiChatResponse {
  reply: string;
}
